import { 
  LuKeyRound, LuDog,
  LuDribbble, LuPartyPopper, LuConstruction
} from "react-icons/lu";

const features = [
  {
    name: 'Be An Owner',
    icon: LuKeyRound,
    description:
      'Like our customers we want everyone to act like an owner. Be responsible and accountable for our work, work hard and be rewarded for it.',
  },
  {
    name: 'Be Human',
    icon: LuDog,
    description:
      'Learn quickly from mistakes, continually improve, and be resourceful to get the job done.',
  },
  {
    name: 'Win The Right Way',
    icon: LuDribbble,
    description: 'Speak up, tell the hard truths, be transparent, and be intentional to do the right thing.',
  },
  {
    name: 'Collaboration Wins',
    icon: LuPartyPopper,
    description:
      'Share in other peoples success and be open to crazy ideas. Collective teamwork is stronger than the individual.',
  },
  {
    name: 'Always Be Changing',
    icon: LuConstruction,
    description: 'You either get better or your get worse, you never stay the same. Fight to get better.',
  }
]

export default function Values() {
  return (
    <div className="bg-white pt-16 sm:pt-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl tracking-tight text-gray-900 sm:text-4xl">Our Core Values</h2>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            We rely on these core values to guide our identity on who we want to be for ourselves and our customers.
          </p>
        </div>
        <dl className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-8 text-base leading-7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {features.map((feature) => (
            <div key={feature.name} className="border p-4 rounded-md border-pinto/20 bg-pinto/10">
              <dt className="font-semibold text-gray-900 flex items-center">
                {feature.icon && <feature.icon size="22" className="text-pinto-dark mr-2"/>} 
                {feature.name}
              </dt>
              <dd className="mt-1 text-gray-600">{feature.description}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  )
}
